import { CancelToken } from 'axios';
import { BaseDataService } from '../../../services/base/BaseDataService';
import { PDFNoteWorkflowInstanceQuery } from '../models/PDFNoteWorkflowInstanceQuery';
import { PDFNoteWorkflowInstance } from '../models/PDFNoteWorkflowInstance';
import { User } from '../../settings/users/models/User';
import { WorkflowCriticalNoteResult } from '../models/WorkflowCriticalNoteResult';

export class PDFNoteWorkflowInstanceService extends BaseDataService<
    PDFNoteWorkflowInstance,
    PDFNoteWorkflowInstanceQuery
> {
    protected prefixUrl: string = `PDFNoteWorkflowInstances`;

    /** Список авторов замечаний для фильтра при формировании реестра замечаний. */
    fetchAuthorsForNotesRegistry(query: PDFNoteWorkflowInstanceQuery, cancelToken?: CancelToken) {
        return this.api.get<User[]>(
            `${this.prefixUrl}/FetchAuthorsForNotesRegistry?query=${encodeURIComponent(JSON.stringify(query))}`,
            { cancelToken },
        );
    }

    fetchCriticalFolderFlags(projectDocId: number, cancelToken?: CancelToken) {
        return this.api.get<WorkflowCriticalNoteResult[]>(
            `${this.prefixUrl}/FetchCriticalFolderFlags/${projectDocId}`,
            { cancelToken },
        );
    }
}
